import React from "react";  

import {  
    
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";
import { Row, Col } from "reactstrap";

import DashboardListsPaycheck from "components/Dashboard/Lists/Paycheck";

export default function DashboardListPaycheck(){  

    return ( 
        <>
            <ContainerAuthenticated page={"paycheck"}> 
                <Row> 
                    <Col sm={12} md={12}>
                        <DashboardListsPaycheck />
                    </Col>
                </Row>
            </ContainerAuthenticated> 
        </>
    );
}